<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="flowAreaWorkForm" :model="formData" class="full-width-input" :disable="readOnly"
      :rules="rules" style="width: 100%;"
      label-width="200px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="活动内容(100字以上)" prop="AreaWork.workContent">
            <el-input class="input-item" v-if="!readOnly" v-model="formData.AreaWork.workContent"
              type="textarea"
              :autosize="{minRows: 2, maxRows: 4}"
              :clearable="true" placeholder="活动内容(100字以上)"
            />
            <span class="input-item input-label" v-else>{{formData.AreaWork.workContent}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="现场图片" prop="AreaWork.siteImages">
<!--            <el-upload v-if="!readOnly"-->
<!--              class="upload-image-item" name="uploadFile" :headers="getUploadHeaders"-->
<!--              :action="getUploadActionUrl('/admin/app/areaWork/upload')"-->
<!--              :data="{fieldName: 'siteImages', asImage: true}"-->
<!--              :on-success="onSiteImagesUploadSuccess"-->
<!--              :on-remove="onSiteImagesRemoveFile"-->
<!--              :before-upload="pictureFile"-->
<!--              :on-error="onUploadError"-->
<!--  -->
<!--              :show-file-list="false">-->
<!--              <div v-if="flowAreaWorkForm.siteImages.impl.fileList && flowAreaWorkForm.siteImages.impl.fileList[0] != null" style="position: relative">-->
<!--                <img class="upload-image-show"-->
<!--                  :src="flowAreaWorkForm.siteImages.impl.fileList[0].url" />-->
<!--                <div class="upload-img-del el-icon-close"-->
<!--                  @click.stop="onSiteImagesRemoveFile(null, null)" />-->
<!--              </div>-->
<!--              <i v-else class="el-icon-plus upload-image-item"></i>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <img v-for="item in flowAreaWorkForm.siteImages.impl.fileList" :key="item.url"-->
<!--                class="table-cell-image" :src="item.url" />-->
<!--            </template>-->

            <el-upload v-if="!readOnly"
                       class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
                       :action="getUploadActionUrl('/admin/app/areaWork/upload')"
                       :data="{fieldName: 'siteImages', asImage: true}"
                       :on-success="onSiteImagesUploadSuccess"
                       :on-remove="onSiteImagesRemoveFile"
                       :before-upload="pictureFile"
                       :on-error="onUploadError"
                       :show-file-list="true"
                       :on-preview="handlePreview"
                       :limit="flowAreaWorkForm.siteImages.impl.maxCount"
                       :on-exceed="onUploadLimit"
                       :file-list="flowAreaWorkForm.siteImages.impl.fileList"
                       list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <template v-else>
              <el-image v-for="item in parseUploadData(formData.AreaWork.siteImages, {id: formData.AreaWork.id,
                  fieldName: 'siteImages', asImage: true})"
                        :preview-src-list="getPictureList(formData.AreaWork.siteImages, {id: formData.AreaWork.id, fieldName: 'siteImages', asImage: true})"
                        class="table-cell-image" :key="item.url" :src="item.url" fit="scale-down">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>

          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="附件" prop="AreaWork.attachedFiles">
<!--            <el-upload v-if="!readOnly" name="uploadFile" :headers="getUploadHeaders" multiple-->
<!--              :action="getUploadActionUrl('/admin/app/areaWork/upload')"-->
<!--              :data="{fieldName: 'attachedFiles', asImage: false}"-->
<!--              :on-success="onAttachedFilesUploadSuccess"-->
<!--              :on-remove="onAttachedFilesRemoveFile"-->
<!--              :on-error="onUploadError" :on-exceed="onUploadLimit"-->
<!--              :limit="flowAreaWorkForm.attachedFiles.impl.maxCount"-->
<!--              :file-list="flowAreaWorkForm.attachedFiles.impl.fileList"-->
<!--              :show-file-list="true">-->
<!--              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>-->
<!--            </el-upload>-->
<!--            <template v-else>-->
<!--              <a v-for="item in flowAreaWorkForm.attachedFiles.impl.fileList" :key="item.url"-->
<!--                href="javascript:void(0);" @click="downloadFile(item.url, item.name)">-->
<!--                {{item.name}}-->
<!--              </a>-->
<!--            </template>-->
            <el-upload name="uploadFile" :headers="getUploadHeaders" multiple v-if="!readOnly"
                       :action="getUploadActionUrl('/admin/app/areaWork/upload')"
                       :data="{fieldName: 'attachedFiles', asImage: false}"
                       :on-success="onAttachedFilesUploadSuccess"
                       :on-remove="onAttachedFilesRemoveFile"
                       :on-error="onUploadError" :on-exceed="onUploadLimit"
                       :limit="flowAreaWorkForm.attachedFiles.impl.maxCount"
                       :file-list="flowAreaWorkForm.attachedFiles.impl.fileList"
                       :show-file-list="false">
              <el-button :size="defaultFormItemSize" type="primary">点击上传</el-button>
            </el-upload>
            <div v-if="flowAreaWorkForm.attachedFiles.impl.fileList && flowAreaWorkForm.attachedFiles.impl.fileList[0] != null" style="position: relative">
              <div v-for="(item,index) in flowAreaWorkForm.attachedFiles.impl.fileList" :key="item.url"
                   style="display:flex;margin-top: 5px;">
                <div> {{item.name}}</div>
                <div style="margin-left: 15px;display: inline-flex">

                  <el-button type="primary" @click="downloadFile(item.url, item.name)">下载</el-button>
                  <el-button type="primary" @click="previewFile(item.url, item.filename)">预览</el-button>
                  <el-button type="primary" v-if="!readOnly"
                             @click="deleteAttachedFiles(item,flowAreaWorkForm.attachedFiles.impl.fileList,index)">删除</el-button>
                </div>

              </div>
            </div>
            <template v-else>
              <a v-for="item in flowAreaWorkForm.attachedFiles.impl.fileList" :key="item.url"
                 href="javascript:void(0);" @click="downloadFile(item.url, item.name)">
                {{item.name}}
              </a>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />

  </div>
</template>

<script>
import { mapActions } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
import flowMixins from '../../mixins/flowMixins.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { AreaWorkController, DictionaryController } from '@/api';
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowAreaWork';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'flowAreaWorkForm',
  props: {
    // 是否运行时任务
    isRuntimeTask: {
      type: [Boolean, String]
    },
    // 是否草稿
    isDraft: {
      type: [Boolean, String],
      default: false
    },
    // 是否只读
    readOnly: {
      type: Boolean,
      default: false
    },
    // 流程实例id
    processInstanceId: {
      type: String
    },
    // 抄送消息id
    messageId: {
      type: String
    },
    // 当前任务实例id
    taskId: {
      type: String
    },
    // 任务变量列表
    taskVariableList: {
      type: Array
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, flowMixins],
  data () {
    return {
      imgViewerVisible: false,
      imgList: [],
      formData: {
        AreaWork: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          workContent: undefined,
          siteImages: undefined,
          attachedFiles: undefined,
          areaId: undefined,
          mediaAdoption: undefined,
          isDatasourceInit: false
        }
      },
      // 保存草稿后返回的taskId
      draftTaskId: undefined,
      // 保存草稿后返回的流程实例ID
      draftProcessInstanceId: undefined,
      rules: {
        'AreaWork.workContent': [
          {required: true, message: '请输入活动内容', trigger: 'blur'},
          { min: 100, message: '100字以上', trigger: 'blur' }
        ],
        'AreaWork.siteImages': [
          {required: true, message: '请输入现场图片', trigger: 'blur'}
        ]
      },
      flowAreaWorkForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        siteImages: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(1)
        },
        isInit: false
      }
    }
  },
  methods: {
    // 启动流程
    handlerStart (operation, copyItemList, xml) {
      // 启动并保存草稿后再次提交
      if (this.draftProcessInstanceId != null && this.draftTaskId != null) {
        return this.handlerOperation(operation, copyItemList);
      }
      return new Promise((resolve, reject) => {
        this.$refs.flowAreaWorkForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, true, xml).then(res => {
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            return AreaWorkController.startAndTakeUserTaskFlowAreaWork(this, {
              processDefinitionKey: processDefinitionKey,
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              flowTaskCommentDto: {
                approvalType: operation.type
              },
              areaWorkDto: {
                ...formData.masterData
              },
              ...formData.relationData,
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            });
          }).then(res => {
            this.$message.success('启动成功！');
            resolve();
          }).catch(e => {
            reject(e);
          });
        });
      });
    },
    // 流程操作
    handlerOperation (operation, copyItemList, xml) {
      return new Promise((resolve, reject) => {
        this.$refs.flowAreaWorkForm.validate(valid => {
          if (!valid) return reject();
          this.preHandlerOperation(operation, this.isDraft, xml).then(res => {
            // 加签、减签操作
            if (operation.type === this.SysFlowTaskOperationType.CO_SIGN || operation.type === this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              return this.submitConsign((res || {}).assignee, operation.type === this.SysFlowTaskOperationType.CO_SIGN);
            }
            // 自由跳
            if (operation.type === this.SysFlowTaskOperationType.FREE_JUMP) {
              return FlowOperationController.freeJump(this, {
                processInstanceId: this.processInstanceId,
                sourceTaskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                delegateAssignee: (res || {}).assignee,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回操作
            if (operation.type === this.SysFlowTaskOperationType.REJECT || operation.type === this.SysFlowTaskOperationType.REJECT_TO_TASK) {
              return FlowOperationController.rejectRuntimeTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                targetTaskKey: (res || {}).targetTaskKey,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 驳回到起点
            if (operation.type === this.SysFlowTaskOperationType.REJECT_TO_START) {
              return FlowOperationController.rejectToStartUserTask(this, {
                processInstanceId: this.processInstanceId,
                taskId: this.taskId,
                taskComment: (res || {}).message,
                taskVariableData: {
                  latestApprovalStatus: operation.latestApprovalStatus
                }
              });
            }
            // 撤销操作
            if (operation.type === this.SysFlowTaskOperationType.REVOKE) {
              this.$confirm('是否撤销此任务？').then(res => {
                return FlowOperationController.rejectHistoricTask(this, {
                  processInstanceId: this.processInstanceId,
                  taskId: this.taskId,
                  taskComment: '任务处理人撤销任务',
                  taskVariableData: {
                    latestApprovalStatus: operation.latestApprovalStatus
                  }
                });
              }).catch(e => {
                return Promise.reject(e);
              });
            }
            let formData = this.getMasterData(operation.type, (res || {}).assignee);
            let params = {
              taskId: this.taskId || this.draftTaskId,
              processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
              flowTaskCommentDto: {
                taskComment: (res || {}).message,
                approvalType: operation.type,
                delegateAssignee: operation.type === this.SysFlowTaskOperationType.TRANSFER ? (res || {}).assignee : undefined
              },
              taskVariableData: {
                ...formData.taskVariableData,
                latestApprovalStatus: operation.latestApprovalStatus
              },
              copyData: (copyItemList || []).reduce((retObj, item) => {
                retObj[item.type] = item.id;
                return retObj;
              }, {})
            }
            // 非只读状态下，提交修改数据
            if (!this.readOnly) {
              // 主表数据
              params.areaWorkDto = {
                ...formData.masterData
              };
              // 关联数据
              params = {
                ...params,
                ...formData.relationData
              };
            }

            return AreaWorkController.submitUserTaskFlowAreaWork(this, params);
          }).then(res => {
            this.reloadMessage(this);
            if (operation.type !== this.SysFlowTaskOperationType.CO_SIGN && operation.type !== this.SysFlowTaskOperationType.SIGN_REDUCTION) {
              this.$message.success(operation.label + '成功！');
            }
            resolve();
          }).catch(e => {
            console.log(e);
          });
        });
      });
    },
    // 保存草稿
    handlerDraft () {
      return new Promise((resolve, reject) => {
        let formData = this.getFormDataImpl();
        let params = {
          processDefinitionKey: processDefinitionKey,
          processInstanceId: this.processInstanceId || this.draftProcessInstanceId,
          areaWorkDto: {
            ...formData.masterData
          },
          ...formData.relationData
        }
        AreaWorkController.startAndSaveDraftFlowAreaWork(this, params).then(res => {
          this.$message.success('草稿保存成功！');
          this.draftProcessInstanceId = res.data.processInstanceId;
          this.draftTaskId = res.data.taskId;
          resolve();
        }).catch(e => {
          reject(e);
        });
      });
    },
    // 获取表单数据
    getFormDataImpl () {
      // 一对一、一对多、多对多关联数据
      let relationData = {};

      return {
        masterData: {
          ...this.formData.AreaWork
        },
        relationData: relationData
      }
    },
    // 获取流程表单数据
    getMasterData (operationType, assignee) {
      let taskVariableData;
      if (Array.isArray(this.taskVariableList) && this.taskVariableList.length > 0) {
        taskVariableData = this.taskVariableList.reduce((retObj, item) => {
          retObj[item.variableName] = this.formData.AreaWork[item.variableName] || '';
          return retObj;
        }, {});
      }
      // 会签操作设置多实例处理人集合
      assignee = (assignee && assignee !== '') ? assignee.split(',') : undefined;
      if (operationType === this.SysFlowTaskOperationType.MULTI_SIGN) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.assigneeList = assignee;
      } else if (operationType === this.SysFlowTaskOperationType.SET_ASSIGNEE) {
        if (taskVariableData == null) taskVariableData = {};
        taskVariableData.appointedAssignee = Array.isArray(assignee) ? assignee.join(',') : undefined;
      }

      return {
        ...this.getFormDataImpl(),
        taskVariableData
      }
    },
    // 初始化流程表单
    initFormData () {
      if (!this.isStartFlow) {
        // 流程办理
        let params = {
          processInstanceId: this.processInstanceId,
          taskId: this.taskId
        }
        let httpCall = null;
        if (this.isDraft || this.isDraft === 'true') {
          // 草稿数据
          httpCall = FlowOperationController.viewDraftData(this, {
            processDefinitionKey: processDefinitionKey,
            processInstanceId: this.processInstanceId
          });
        } else if (this.messageId != null) {
          // 抄送消息
          httpCall = FlowOperationController.viewCopyBusinessData(this, {
            messageId: this.messageId
          });
        } else {
          httpCall = (this.taskId && this.isRuntime) ? AreaWorkController.viewTaskBusinessDataFlowAreaWork(this, params) : AreaWorkController.viewHistoricTaskBusinessDataFlowAreaWork(this, params)
        }
        httpCall.then(res => {
          this.formData.AreaWork = { ...res.data };
          let siteImagesDownloadParams = {
            id: this.formData.AreaWork.id,
            fieldName: 'siteImages',
            asImage: true
          }
          this.flowAreaWorkForm.siteImages.impl.fileList = this.parseUploadData(this.formData.AreaWork.siteImages, siteImagesDownloadParams);
          let attachedFilesDownloadParams = {
            id: this.formData.AreaWork.id,
            fieldName: 'attachedFiles',
            asImage: false
          }
          this.flowAreaWorkForm.attachedFiles.impl.fileList = this.parseUploadData(this.formData.AreaWork.attachedFiles, attachedFilesDownloadParams);
          // 获取一对多、多对多数据
          this.refreshFlowAreaWorkForm(true);
        }).catch(e => {});
      } else {
        // 启动流程
      }
    },
    onCancel (isSuccess) {
      if (this.observer != null) {
        this.observer.cancel(isSuccess);
      }
    },
    /**
     * 更新辖区工作表单
     */
    refreshFlowAreaWorkForm (reloadData = false) {
      if (!this.flowAreaWorkForm.isInit) {
        // 初始化下拉数据
      }
      this.flowAreaWorkForm.isInit = true;
    },
    /**
     * 现场图片上传成功
     */
    onSiteImagesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowAreaWorkForm.siteImages.impl.onFileChange(file, fileList);
        this.formData.AreaWork.siteImages = this.fileListToJson(this.flowAreaWorkForm.siteImages.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除现场图片
     */
    onSiteImagesRemoveFile (file, fileList) {
      this.flowAreaWorkForm.siteImages.impl.onFileChange(file, fileList);
      this.formData.AreaWork.siteImages = this.fileListToJson(this.flowAreaWorkForm.siteImages.impl.fileList);
    },
    /**
     * 附件上传成功
     */
    onAttachedFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.flowAreaWorkForm.attachedFiles.impl.onFileChange(file, fileList);
        this.formData.AreaWork.attachedFiles = this.fileListToJson(this.flowAreaWorkForm.attachedFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除附件
     */
    onAttachedFilesRemoveFile (file, fileList) {
      this.flowAreaWorkForm.attachedFiles.impl.onFileChange(file, fileList);
      this.formData.AreaWork.attachedFiles = this.fileListToJson(this.flowAreaWorkForm.attachedFiles.impl.fileList);
    },
    deleteAttachedFiles (file, fileList, index) {
      fileList.splice(index, 1)
      this.onAttachedFilesRemoveFile(file, fileList)
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    formInit () {
      this.initFormData();
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    ...mapActions(['reloadMessage'])
  },
  computed: {
    isStartFlow () {
      return this.processInstanceId == null;
    },
    isRuntime () {
      return typeof this.isRuntimeTask === 'string' ? this.isRuntimeTask === 'true' : this.isRuntimeTask;
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  }
}
</script>
